import {IAutoDeletePeriod, IBillingData, INewPassword, ITimezone, IUserProfile} from '@interfaces/user';
import {ViewType} from '@shared/enums/view-type.enum'
import {UserRole} from '@shared/enums/user-roles.enum';

export class GetUser {
  static readonly type = '[User] Get User';
}

export class UpdateUserData {
  static readonly type = '[User] Update user data';

  constructor(public profile: IUserProfile) {
  }
}

export class ToggleTwoFA {
  static readonly type = '[User] Toggle two FA';

  constructor(public event: boolean) {
  }
}

export class UpdateIpWhiteList {
  static readonly type = '[User] Update ip whitelist';

  constructor(public ipList: string) {
  }
}

export class UpdatePassword {
  static readonly type = '[User] Update password';

  constructor(public pass: INewPassword) {
  }
}

export class UpdateTimezone {
  static readonly type = '[User] Update timezone';

  constructor(public timezone: ITimezone) {
  }
}

// Device management Actions
export class GetDeviceManagementSettings {
  static readonly type = '[User] Get Device management settings';
}

export class ToggleDeviceManagementStatus {
  static readonly type = '[User] Device management status toggle';

  constructor(public status: boolean) {
  }
}

export class ToggleAutoenrollStatus {
  static readonly type = '[User] Device Autoenroll status toggle';

  constructor(public status: boolean) {
  }
}

export class ToggleAutoDeleteStatus {
  static readonly type = '[User] Device AutoDelete status toggle';

  constructor(public status: boolean) {
  }
}

export class ChangeAutoDeletePeriod {
  static readonly type = '[User] Change AutoDelete Period';

  constructor(public period: IAutoDeletePeriod) {
  }
}

export class ToggleStatisticStatus {
  static readonly type = '[User] Toggle Statistic status';

  constructor(public status: boolean) {
  }
}

export class ToggleDeviceView {
  static readonly type = '[Devices] Toggle View type';

  constructor(public type: ViewType) {
  }
}

export class GetCompanyData {
  static readonly type = '[User] Get Company Data';
}

export class GetFeaturesConfig {
  static readonly type = '[User] Get features config';
}

export class GetCompanyUsers {
  static readonly type = '[User] Get company users';
}

export class AddUser {
  static readonly type = '[User] Add user';

  constructor(public user: {name: string, pass: string, email: string, role: UserRole}) {
  }
}

export class DeleteUser {
  static readonly type = '[User] Delete user';

  constructor(public id: number) {
  }
}

export class UpdateUser {
  static readonly type = '[User] update user';

  constructor(public data: {id: number, account_blocked: boolean}) {
  }
}

export class ToggleMarketplaceMode {
  static readonly type = '[User] Toggle marketplace mode';

  constructor(public status: boolean) {
  }
}

export class SetAutoRemoteUpdateStatus {
  static readonly type = '[User] Update auto remote status';

  constructor(public status: boolean) {
  }
}

export class UpdateMarketplaceUserData {
  static readonly type = '[User] update marketplace tv-owner data';

  constructor(public data: IBillingData) {
  }
}
